import React, { Component } from "react";
import MNP from "../views/numbers/mnp/ksa/mnp.component";
import Translations from "../services/translation.service";

export default class mnp_form extends Component {
	subscriptions = [];
	componentDidMount() {
		window.scrollTo({ top: 0, behavior: "smooth" });
		this.subscriptions.push(
			Translations.getKeysObsrv().subscribe(data => {
				this.forceUpdate();
			})
		);
	}

  render() {
    return <MNP />;
  }
}